import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "escape-if-you-can-logo" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bottomLine" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 text-sm mr-4" }, "© 2022 escape if you can")
], -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, _hoisted_3))
}